"use client";

import dynamic from "next/dynamic";

const SwellChart = dynamic(
  () =>
    import("@/app/_components/conditions/SwellChart").then((m) => ({
      default: m.SwellChart,
    })),
  { ssr: false, loading: () => <div className="h-[300px]" /> }
);

export { SwellChart as SwellChartLazy };
